import styled from "@emotion/styled";
import { Button, keyframes } from "@mui/material";
import { DateTime } from "luxon";

interface Props {
  isLive: boolean;
  lastUpdate?: DateTime;
  onClick?: VoidFunction;
}

export const LiveBadge = ({ isLive, lastUpdate, onClick }: Props) => {
  return (
    <Container onClick={onClick}>
      {lastUpdate && (
        <UpdateDate>
          Last update: {lastUpdate?.toFormat("FF") || "-"}
        </UpdateDate>
      )}
      <LiveButton
        size="small"
        variant="outlined"
        endIcon={isLive ? <DotIcon /> : <DotIconEmpty />}
      >
        Live
      </LiveButton>
    </Container>
  );
};

const bounce = keyframes`
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(62, 228, 55, 0.7);
    }
    
    70% {
      transform: scale(1);
      box-shadow: 0 0 0 5px rgba(62, 228, 55, 0);
    }
    
    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(62, 228, 55, 0);
    }
`;

const UpdateDate = styled.p({
  fontSize: ".6rem",
  lineHeight: 2,
  paddingRight: ".5rem",
  borderRight: ".5px solid white",
  marginRight: ".5rem",
  color: "white",
  whiteSpace: "nowrap",
});

const Container = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: ".5rem 0",
});

const DotIcon = styled.div(() => ({
  background: "rgba(62, 228, 55)",
  borderRadius: "50%",
  height: ".4rem",
  width: ".4rem",
  boxShadow: "0 0 0 0 rgba(62, 228, 55)",
  transform: "scale(1)",
  animation: `${bounce} 2s ease infinite`,
}));

const DotIconEmpty = styled.div((props: any) => ({
  borderRadius: "50%",
  height: ".4rem",
  width: ".4rem",
  backgroundColor: props.theme.palette.grey[600],
  //   border: "1px solid white",
}));

const LiveButton = styled(Button)((props: any) => ({
  borderRadius: "20rem",
  padding: "0.2rem 1rem 0.2rem 1rem",
  color: "white",
  borderColor: props.theme.palette.grey[600],
  borderWidth: "0.5px",
  fontSize: ".6rem",
}));
